/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Area from 'pages/dashboard/reports/detail/area/area';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
import Field from 'material/form/field/field_container';
import List from 'material/list/list';
import Tip from 'material/message/tip/tip';
import DateRangePickerDropdown from 'material/dropdowns/daterangepickerdropdown/daterangepickerdropdown';
//utils
import { isAfterFourPM } from 'utils/isafterfourpm';
import { validation } from 'utils/validation';
import zeroPadding from 'utils/zeroPadding';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/settings/settings_styles';


/* ========== ~~~~~~~~~~ REPORT DETAIL : AREA : SETTINGS ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ReportSettings = (props) => {
    const rangeFormat = (range) =>{
        let { to, from } = range;
        return ({ from:`${from.getFullYear()}-${zeroPadding((from.getMonth() + 1), 2)}-${zeroPadding(from.getDate(), 2)}`,
            to:`${to.getFullYear()}-${zeroPadding((to.getMonth() + 1), 2)}-${zeroPadding(to.getDate(), 2)}` });
    };
    return (
        <Area name={`settings`} klass = {`${props.classes.settings}`} title = {`Report Settings`}>
            <GridSet klass={'settings_content'} direction = {`vertical`}>
                <GridItem klass={`settings_section`}>
                <p className={`settings_subheading`}>Name your report:</p>
                <Field  klass={'report_name'}
                        type={'text'}
                        name={'reportName'}
                        value={props.name}
                        placeholder={`E.g 'Last 7 days daily report'`}
                        handleBlur={(event) =>  props.setReportProperties({selectedReportDataValid: Object.assign({}, props.valid, { settings: validation.reportName.test.test(event.target.value)}),
                                                  name: event.target.value})}
                        handleChange={(event) => props.setReportProperties({selectedReportDataValid: Object.assign({}, props.valid, { settings: validation.reportName.test.test(event.target.value)}),
                                                  name: event.target.value})}
                        valid={props.valid.settings}
                        required
                    />
                </GridItem>
                <GridItem klass={'settings_section'}>
                <p className={'settings_subheading'}>Select a date range:
                    <Tip space={`left`}
                         content = {<p>Select the date range that you want your report to cover. All data displayed and available is in EST time zone.</p>}/></p>
                <List type={'fancy-radio'}
                      items={[{ value: 'YESTERDAY', text: <span>Yesterday <Tip icon={'exclamation-circle'} space={`none`} content={<p>{`Report data for this selection is only available after 5:30pm EDT`}</p>}/></span>},
                                { value: 'LAST_SEVEN_DAYS', text: 'Last 7 Days' },
                                { value: 'LAST_THIRTY_DAYS', text: 'Last 30 Days' },
                                { value: 'LAST_WEEK', text: 'Last week (Monday - Sunday)' },
                                { value: 'LAST_MONTH', text: 'Last month (first to last days of month)' },
                                { value: 'CUSTOM', text: <span>Custom <Tip icon={'exclamation-circle'} space={`none`} content={<p>{`You will not be able to schedule recurring reports for this option`}</p>}/></span>}]}
                        selected={props.dateRange}
                        handleChange={newDateRange => props.dateRange !== newDateRange ? props.setReportProperties({dateRange: newDateRange}) : null} />
                {props.dateRange === 'CUSTOM' ?
                <DateRangePickerDropdown klass={'date_picker'}
                                         alignedRight={true}
                                         hideDateRangeHelpers={true}
                                         hideButtons={true}
                                         range={props.customDateRange}
                                         updateRange={(customDateRange)=>{props.setReportProperties({customDateRange: customDateRange})}}
                                         disabledDays={[ { after: new Date(new Date() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]}
                /> : null}
                </GridItem>
            </GridSet>
        </Area>
    );
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(ReportSettings);
